import React from 'react';
import { Plus } from '@phosphor-icons/react';
import classNames from 'classnames';

interface Props {
  element: any;
  addClass?: string;
}

const SampleAddOverlay: React.FC<Props> = (props) => {
  const { element, addClass } = props;

  if (element.isSelected) return null;

  return (
    <div
      className={classNames(
        addClass,
        'group absolute top-0 left-0 flex items-center justify-center bg-black-overlay-600 text-center text-white',
      )}
    >
      <div className="absolute w-4/5 transition-all group-hover:opacity-0">
        Click to add
      </div>

      <Plus className="absolute text-[3em] transition-all opacity-0 group-hover:opacity-100" />
    </div>
  );
};

export default SampleAddOverlay;
